import axios from 'axios';
import React from 'react';
import Properties from "../const/Properties";
import CustomModal from "../thema/tema1/component/CustomModal";
import Footer from "../thema/tema1/component/Footer";
import Header from "../thema/tema1/component/Header";
import PageContext from "../thema/tema1/component/PageContext";
import SideMenu from "../thema/tema1/component/SideMenu";
import { withRouter } from 'react-router-dom';

const active = { Home: "active" };

class UcretBelirle extends React.Component {
    constructor(props) {
        super(props);
        //alert(this.props.match.params.id);
        this.state = {
            tasimaId: this.props.match.params.id,
            gemiUcreti: false,
            hepsiGemi: false,
            hepsiUcak: false,
            gemiUcretiOdeme: 0,
            gemiUcretiMuhasebe: 0,
            baf: false,
            bafOdeme: 0,
            bafMuhasebe: 0,
            ets: false,
            etsOdeme: 0,
            etsMuhasebe: 0,
            liman: false,
            limanOdeme: 0,
            limanMuhasebe: 0,
            soforUcreti: 0,
            soforUcretiOdeme: 0,
            soforUcretiMuhasebe: 0,
            ekSofor: 0,
            ekSoforOdeme: 0,
            ekSoforMuhasebe: 0,
            xray: false,
            xrayOdeme: 0,
            xrayMuhasebe: 0,
            yanici: false,
            yaniciOdeme: 0,
            yaniciMuhasebe: 0,
            rezervasyon: false,
            rezervasyonOdeme: 0,
            rezervasyonMuhasebe: 0,
            forklift: 0,
            forkliftOdeme: 0,
            forkliftMuhasebe: 0,
            ceza: 0,
            cezaOdeme: 0,
            cezaMuhasebe: 0,
            yolGecisUcreti: 0,
            yolGecisUcretiOdeme: 0,
            yolGecisUcretiSecim: "",
            gidecegiUlke: 0,
            gidecegiUlkeOdeme: 0,
            sigorta: 0,
            sigortaOdeme: 0,
            sigortaSecim: "",
            sigortaMuhasebe: 0,
            sigorta1ay: 0,
            sigorta2ay: 0,
            sigorta3ay: 0,
            gurbulak: 0,
            esendere: 0,
            dilucu: 0,
            toplam: 0.0,
            content: [],
            pageCount: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            silModal: 'none',
            title: ["STATU", "TARİH", "ÇEKİCİ PLAKA", "İŞLEM ÜCRETİ", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            error: 0
        };
        this.get();

    }

    componentDidMount() {
        this.gecislerDoldur();
    }
    gecislerDoldur = () => {
            let status = true;
            if (status) {
                axios({
                    method: 'get',
                    url: Properties.baseUrl + '/tarife/get',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    }
                })
                    .then(res => {
                        console.log(res.data);
                        this.setState({ sigorta1ay: res.data.sigorta1ay });
                        this.setState({ sigorta2ay: res.data.sigorta2ay });
                        this.setState({ sigorta3ay: res.data.sigorta3ay });
                        this.setState({ gurbulak: res.data.gurbulak });
                        this.setState({ esendere: res.data.esendere });
                        this.setState({ dilucu: res.data.dilucu });
                    }).catch(res => {
                    window.unsuccessful((this.state.showDuzenle ? "Tarife Güncellenemedi." : "Tarife Kaydedilemedi."));
                });
            }
    }
    geri = (e) => {
        window.location = document.referrer;
    }
    onChange = e => {
        this.setState({ [e.target.name]: e.target.value });

        if(e.target.name === "sigorta")
        {
            this.setState({ "sigortaSecim": e.target.options[e.target.selectedIndex].text });
        }
        if(e.target.name === "yolGecisUcreti")
        {
            this.setState({ "yolGecisUcretiSecim": e.target.options[e.target.selectedIndex].text });
        }


        this.hesapla();
    }
    onChangeCheck = e => {
        console.log([e.target.name]);
        if (e.target.checked) {
            this.setState({ [e.target.name]: 1 });
            if(e.target.name === "hepsiGemi")
            {
                this.setState({ "hepsiGemi":1 });
                this.setState({ "gemiUcreti":1 });
                this.setState({ "ets":1 });
                this.setState({ "baf":1 });
                this.setState({ "liman":1 });
                this.setState({ "xray":1 });
                this.setState({ "soforUcreti": 1 });
            }
            if(e.target.name === "hepsiUcak")
            {
                this.setState({ "hepsiUcak":1 });
                this.setState({ "gemiUcreti":1 });
                this.setState({ "ets":1 });
                this.setState({ "baf":1 });
                this.setState({ "liman":1 });
                this.setState({ "xray":1 });
                this.setState({ "soforUcreti": 2 });
            }
        }
        else {
            this.setState({ [e.target.name]: 0 });
            if(e.target.name === "hepsiGemi")
            {
                this.setState({ "hepsiGemi":0 });
                this.setState({ "gemiUcreti":0 });
                this.setState({ "ets":0 });
                this.setState({ "baf":0 });
                this.setState({ "xray":0 });
                this.setState({ "liman":0 });
                this.setState({ "soforUcreti": 0 });
            }
            if(e.target.name === "hepsiUcak")
            {
                this.setState({ "hepsiUcak":0 });
                this.setState({ "gemiUcreti":0 });
                this.setState({ "ets":0 });
                this.setState({ "baf":0 });
                this.setState({ "xray":0 });
                this.setState({ "liman":0 });
                this.setState({ "soforUcreti": 0 });
            }
        }
        this.hesapla();
    }
    get = e => {
        let status = true;
        if (status) {

            axios({
                method: 'get',
                url: Properties.baseUrl + '/ucretbelirle/get/'+this.state.tasimaId,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                }
            })
                .then(res => {
                    this.setState({ gemiUcreti: res.data.gemiUcreti });
                    this.setState({ gemiUcretiOdeme: res.data.gemiUcretiOdeme });
                    this.setState({ gemiUcretiMuhasebe: res.data.gemiUcretiMuhasebe });
                    this.setState({ baf: res.data.baf });
                    this.setState({ bafOdeme: res.data.bafOdeme });
                    this.setState({ bafMuhasebe: res.data.bafMuhasebe });
                    this.setState({ ets: res.data.ets });
                    this.setState({ etsOdeme: res.data.etsOdeme });
                    this.setState({ etsMuhasebe: res.data.etsMuhasebe });
                    this.setState({ liman: res.data.liman });
                    this.setState({ limanOdeme: res.data.limanOdeme });
                    this.setState({ limanMuhasebe: res.data.limanMuhasebe });
                    this.setState({ soforUcreti: res.data.soforUcreti });
                    if(res.data.soforUcreti == "1")
                    {

                        this.setState({ hepsiGemi: "1" });
                    }
                    else if(res.data.soforUcreti == "2")
                    {

                        this.setState({ hepsiUcak: "1" });
                    }
                    this.setState({ soforUcreti: res.data.soforUcreti });
                    this.setState({ soforUcretiOdeme: res.data.soforUcretiOdeme });
                    this.setState({ soforUcretiMuhasebe: res.data.soforUcretiMuhasebe });
                    this.setState({ ekSofor: res.data.ekSofor });
                    this.setState({ ekSoforOdeme: res.data.ekSoforOdeme });
                    this.setState({ ekSoforMuhasebe: res.data.ekSoforMuhasebe });
                    this.setState({ xray: res.data.xray });
                    this.setState({ xrayOdeme: res.data.xrayOdeme });
                    this.setState({ xrayMuhasebe: res.data.xrayMuhasebe });
                    this.setState({ yanici: res.data.yanici });
                    this.setState({ yaniciOdeme: res.data.yaniciOdeme });
                    this.setState({ yaniciMuhasebe: res.data.yaniciMuhasebe });
                    this.setState({ rezervasyon: res.data.rezervasyon });
                    this.setState({ rezervasyonOdeme: res.data.rezervasyonOdeme });
                    this.setState({ rezervasyonMuhasebe: res.data.rezervasyonMuhasebe });
                    this.setState({ forklift: res.data.forklift });
                    this.setState({ forkliftOdeme: res.data.forkliftOdeme });
                    this.setState({ forkliftMuhasebe: res.data.forkliftMuhasebe });
                    this.setState({ ceza: res.data.ceza });
                    this.setState({ cezaOdeme: res.data.cezaOdeme });
                    this.setState({ cezaMuhasebe: res.data.cezaMuhasebe });
                    this.setState({ yolGecisUcreti: res.data.yolGecisUcreti });
                    this.setState({ yolGecisUcretiOdeme: res.data.yolGecisUcretiOdeme });
                    this.setState({ yolGecisUcretiMuhasebe: res.data.yolGecisUcretiMuhasebe });
                    this.setState({ sigorta: res.data.sigorta });
                    this.setState({ sigortaOdeme: res.data.sigortaOdeme });
                    this.setState({ yolGecisUcretiMuhasebe: res.data.sigortaMuhasebe });
                    this.setState({ yolGecisUcretiSecim: res.data.yolGecisUcretiSecim });
                    this.setState({ sigortaSecim: res.data.sigortaSecim });
                    this.setState({ gidecegiUlke: res.data.gidecegiUlke });
                    this.hesapla(res.data.gidecegiUlke);

                }).catch(res => {
                    window.unsuccessful((this.state.showDuzenle ? "Ek Bilgi Güncellenemedi." : "Ek Bilgi Kaydedilemedi."));
                });
        }
    }
    hesapla = e => {
        let gidecegiUlke = 0
        if(e != undefined)
        {
            gidecegiUlke = e;
        }
        else{
            gidecegiUlke = this.state.gidecegiUlke;
        }
        axios({
            method: 'get',
            url: Properties.baseUrl + '/tarife/get/'+gidecegiUlke,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let localToplam = 0.0;
                if (this.state.gemiUcreti) {
                    localToplam = localToplam + res.data.gemiUcretiTarife;
                    this.setState({ gemiUcretiOdeme: res.data.gemiUcretiTarife });
                }
                else {
                    this.setState({ gemiUcretiOdeme: 0 });
                }
                if (this.state.baf)
                {
                    localToplam = localToplam + res.data.bafTarife;
                    this.setState({ bafOdeme: res.data.bafTarife });
                }
                else{
                    this.setState({ bafOdeme: 0 });
                }
                if (this.state.ets)
                {
                    localToplam = localToplam + res.data.etsTarife;
                    this.setState({ etsOdeme: res.data.etsTarife });
                }
                else{
                    this.setState({ etsOdeme: 0 });
                }
                if (this.state.liman)
                {
                    localToplam = localToplam + res.data.limanTarife;
                    this.setState({ limanOdeme: res.data.limanTarife });
                }
                else{
                    this.setState({ limanOdeme: 0 });
                }
                if (this.state.xray)
                {
                    localToplam = localToplam + res.data.xrayTarife;
                    this.setState({ xrayOdeme: res.data.xrayTarife });
                }
                else{
                    this.setState({ xrayOdeme: 0 });
                }
                if (this.state.yanici)
                {
                    localToplam = localToplam + res.data.yaniciTarife;
                    this.setState({ yaniciOdeme: res.data.yaniciTarife });
                }
                else{
                    this.setState({ yaniciOdeme: 0 });
                }
                if (this.state.rezervasyon)
                {
                    localToplam = localToplam + res.data.rezervasyonTarife;
                    this.setState({ rezervasyonOdeme: res.data.rezervasyonTarife });
                }
                else{
                    this.setState({ rezervasyonOdeme: 0 });
                }
                if (this.state.soforUcreti == 1) {
                    localToplam = localToplam + res.data.soforUcretiTarifeGemi;
                    this.setState({ soforUcretiOdeme: res.data.soforUcretiTarifeGemi });
                }
                else if (this.state.soforUcreti == 2)
                {
                    localToplam = localToplam + res.data.soforUcretiTarifeUcak;
                    this.setState({ soforUcretiOdeme: res.data.soforUcretiTarifeUcak });
                }
                else{
                    this.setState({ soforUcretiOdeme: 0 });
                }
                if (this.state.ekSofor == 1)
                {
                    localToplam = localToplam + res.data.ekSoforTarifeGemi;
                    this.setState({ ekSoforOdeme: res.data.ekSoforTarifeGemi });
                }
                else if (this.state.ekSofor == 2)
                {
                    localToplam = localToplam + res.data.ekSoforTarifeUcak;
                    this.setState({ ekSoforOdeme: res.data.ekSoforTarifeUcak });
                } else{
                    this.setState({ ekSoforOdeme: 0 });
                }
                localToplam = localToplam + parseFloat(this.state.forkliftOdeme);
                localToplam = localToplam + parseFloat(this.state.ceza);
                this.setState({ cezaOdeme: parseFloat(this.state.ceza) });
                localToplam = localToplam + parseFloat(this.state.yolGecisUcreti);
                this.setState({ yolGecisUcretiOdeme: parseFloat(this.state.yolGecisUcreti) });
                localToplam = localToplam + parseFloat(this.state.sigorta);
                this.setState({ sigortaOdeme: parseFloat(this.state.sigorta)});
                this.setState({ toplam: localToplam });
            }).catch(res => {
                window.unsuccessful((this.state.showDuzenle ? "Ücret Belirle  Güncellenemedi." : "Ücret Belirle  Kaydedilemedi."));
            });
    }
    ucretBelirleSave = e => {
        let status = true;
        if (status) {
            axios({
                method: 'post',
                url: Properties.baseUrl + '/ucretbelirle/save',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                data: {
                    tasimaId: this.state.tasimaId,
                    gemiUcreti: this.state.gemiUcreti,
                    gemiUcretiOdeme: this.state.gemiUcretiOdeme,
                    baf: this.state.baf,
                    bafOdeme: this.state.bafOdeme,
                    ets: this.state.ets,
                    etsOdeme: this.state.etsOdeme,
                    liman: this.state.liman,
                    limanOdeme: this.state.limanOdeme,
                    soforUcreti: this.state.soforUcreti,
                    soforUcretiOdeme: this.state.soforUcretiOdeme,
                    ekSofor: this.state.ekSofor,
                    ekSoforOdeme: this.state.ekSoforOdeme,
                    xray: this.state.xray,
                    xrayOdeme: this.state.xrayOdeme,
                    yanici: this.state.yanici,
                    yaniciOdeme: this.state.yaniciOdeme,
                    rezervasyon: this.state.rezervasyon,
                    rezervasyonOdeme: this.state.rezervasyonOdeme,
                    forklift: this.state.forklift,
                    forkliftOdeme: this.state.forkliftOdeme,
                    ceza: this.state.ceza,
                    cezaOdeme: this.state.cezaOdeme,
                    yolGecisUcreti: this.state.yolGecisUcreti,
                    yolGecisUcretiOdeme: this.state.yolGecisUcretiOdeme,
                    sigorta: this.state.sigorta,
                    sigortaOdeme: this.state.sigortaOdeme,
                    yolGecisUcretiSecim: this.state.yolGecisUcretiSecim,
                    sigortaSecim: this.state.sigortaSecim
                }
            })
                .then(res => {
                    window.successful((this.state.showDuzenle ? "Ücret Belirle Güncellendi." : "Ücret Belirle  Kaydedildi"));
                }).catch(res => {
                    window.unsuccessful((this.state.showDuzenle ? "Ücret Belirle  Güncellenemedi." : "Ücret Belirle  Kaydedilemedi."));
                });
            this.geri();
        }
    }
    render() {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header />
                <SideMenu />
                <PageContext>
                    <form>
                        <div className="card card-primary">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-2">
                                        <h3 className="card-title">Ücret Belirle</h3>
                                    </div>
                                </div>

                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div style={{"display": "None"}}>
                                        <div className="col-2" style={{"display": "None"}}>
                                            <label htmlFor="exampleInputPassword1">GEMİ ÜCRETİ</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" name="gemiUcreti"
                                                       checked={this.state.gemiUcreti} onChange={this.onChangeCheck}
                                                       value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <label htmlFor="exampleInputPassword1">BAF</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="aCevap"
                                                       checked={this.state.baf} onChange={this.onChangeCheck}
                                                       name="baf" value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-2" style={{"display": "None"}}>
                                            <label htmlFor="exampleInputPassword1">ETS</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="ets"
                                                       checked={this.state.ets} onChange={this.onChangeCheck}
                                                       name="ets" value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-2" style={{"display": "None"}}>
                                            <label htmlFor="exampleInputPassword1">LİMAN</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="liman"
                                                       checked={this.state.liman} onChange={this.onChangeCheck}
                                                       name="liman" value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-2" style={{"display": "None"}}>
                                            <label htmlFor="exampleInputPassword1">ŞOFÖR ÜCRETİ</label>
                                            <div className="form-check">
                                                <select value={this.state.soforUcreti} name="soforUcreti"
                                                        className="form-control select2" onChange={this.onChange}>
                                                    <option value={0} selected="selected">SEÇ</option>
                                                    <option value={1}>GEMİ</option>
                                                    <option value={2}>UÇAK</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-2">
                                            <label htmlFor="exampleInputPassword1">XRAY</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="xray"
                                                       checked={this.state.xray} onChange={this.onChangeCheck}
                                                       name="xray" value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputPassword1">GEMİ ÜCRETİ KABİN</label>
                                        <div className="form-check">
                                            <input type="checkbox" className="form-check-input" name="hepsiGemi"
                                                   checked={this.state.hepsiGemi} onChange={this.onChangeCheck}
                                                   value={0}/>
                                            <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputPassword1">GEMİ ÜCRETİ UÇAK</label>
                                        <div className="form-check">
                                            <input type="checkbox" className="form-check-input" name="hepsiUcak"
                                                   checked={this.state.hepsiUcak} onChange={this.onChangeCheck}
                                                   value={0}/>
                                            <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputPassword1">EK SÜRÜCÜ</label>
                                        <div className="form-check">
                                            <select value={this.state.ekSofor} name="ekSofor"
                                                    className="form-control select2" onChange={this.onChange}>
                                                <option value={0} selected="selected">SEÇ</option>
                                                <option value={1}>GEMİ</option>
                                                <option value={2}>UÇAK</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputPassword1">YANICI</label>
                                        <div className="form-check">
                                            <input type="checkbox" className="form-check-input" id="yanici"
                                                   checked={this.state.yanici} onChange={this.onChangeCheck}
                                                   name="yanici" value={0}/>
                                            <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputPassword1">FOKLİFT</label>
                                        <div className="form-check">
                                            <input value={this.state.forkliftOdeme} type="number" step="0.1" className="form-control"
                                                   name="forkliftOdeme" onChange={this.onChange}
                                                   placeholder="Foklift Ücreti €"/>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputPassword1">REZERVASYON</label>
                                        <div className="form-check">
                                            <input type="checkbox" className="form-check-input" id="rezervasyon"
                                                   checked={this.state.rezervasyon} onChange={this.onChangeCheck}
                                                   name="rezervasyon" value={0}/>
                                            <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputPassword1">CEZA</label>
                                        <div className="form-check">
                                            <input value={this.state.ceza} type="number" className="form-control"
                                                   name="ceza" onChange={this.onChange}
                                                   placeholder="Ceza Ücreti €"/>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputPassword1">YOL GEÇİŞ ÜCRETİ</label>
                                        <div className="form-check">
                                            <select onChange={this.onChange} name="yolGecisUcreti"
                                                    className="form-control select2" value={this.state.yolGecisUcreti}>
                                                <option value={0} selected="selected">Yol Geçiş Seç</option>
                                                <option value={this.state.gurbulak} selected="selected">GÜRBULAK
                                                </option>
                                                <option value={this.state.esendere} selected="selected">ESENDERE
                                                </option>
                                                <option value={this.state.dilucu} selected="selected">DİLUCU</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputPassword1">SİGORTA</label>
                                        <div className="form-check">
                                            <select onChange={this.onChange} name="sigorta"
                                                    className="form-control select2" value={this.state.sigorta}>
                                                <option value={0} selected="selected">Sigorta Seç</option>
                                                <option value={this.state.sigorta1ay} selected="selected">1 Ay</option>
                                                <option value={this.state.sigorta2ay} selected="selected">2 Ay</option>
                                                <option value={this.state.sigorta3ay} selected="selected">3 Ay</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputPassword1">TOPLAM: {this.state.toplam} €</label>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer row">
                                <div className="col-1">
                                    <button type="button" data-toggle="modal" data-target="#modal-default"
                                            className="btn btn-block btn-primary">Kaydet
                                    </button>
                                </div>
                                <div className="col-1">
                                    <button type="button" onClick={e => this.geri(e)}
                                            className="btn btn-block btn-outline-info">GERİ
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </PageContext>
                <Footer />
                <CustomModal id={"modal-default"} funcModal={this.ucretBelirleSave} title={"Ücret Belirle  Girişi"} content={"Ücret Belirle leri Onaylıyor Musunuz?"}></CustomModal>

            </div>);
    }
}


export default withRouter(UcretBelirle);
